import { Component, OnInit, Input, AfterViewInit, AfterViewChecked, OnChanges, ViewChild } from '@angular/core';
import { UtilService, DialogService, NotificationService, DatagridService } from '../../../shared/index';
import { EventRead } from '../../shared/event-read.model';
import { AttendeeService } from '../shared/attendee.service';
import { EventItemSummary } from '../../shared/items/event-item-summary.model';
import { EventItemService } from '../../shared/items/event-item.service';
import { TranslationService } from '../../../shared/translation/translation.service';
import { RegistrationService } from '../../registration/shared/registration.service';
import { AttendeeSearchParams } from '../shared/attendee-search-params.model';
import { AttendeeSearchResult } from '../shared/attendee-search-result.model';
import { Router, ActivatedRoute } from '@angular/router';
import { EventsService } from '../../shared/events.service';
import { AttendeeMin } from '../shared/attendee-min.model';
import { NameValue } from '../../../shared/model/name-value.model';
import { AffCodeMassAddComponent } from '../../../affcode/affcode-mass-add/affcode-mass-add.component';
import {
  WlEventsToolbarBroadcastService,
  WlEventsToolbarEventTypeEnum,
} from '../../../shared/container/toolbars/module/events/broadcast/index';
import { Table as PrimeDataTable } from 'primeng/table';
import { NavigationService } from '../../../shared/navigation/navigation.service';
import { AttendedFlagOrUnflag } from '../shared/attended-flag-or-unflag.model';
import { AssignAttendeeTable } from '../shared/assign-attendee-table.model';
import { MassCommParameterService } from '../../../communication/shared/mass-comm-parameter.service';
import { MassCommParamNav } from '../../../communication/shared/mass-comm-param-nav.model';
import { UpdateAttendeeCustomFields } from '../shared/update-attendee-custom-fields.model';

@Component({
  selector: 'wl-attendee-management',
  templateUrl: 'attendee-management.component.html',
  styleUrls: ['attendee-management.component.css'],
  providers: [RegistrationService, AttendeeService, EventItemService, MassCommParameterService],
    standalone: false
})
export class AttendeeManagementComponent implements OnInit {
  @ViewChild('massAddAffCode', { static: false }) massAddAffCode: AffCodeMassAddComponent;
  @ViewChild('attendeeDataGrid', { static: true }) public _attendeeDataGrid: PrimeDataTable;

  public _route: ActivatedRoute;
  public _routerService: Router;
  public _utilService: UtilService;
  public _dialogService: DialogService;
  public _notifyService: NotificationService;
  public _registrationService: RegistrationService;
  public _attendeeService: AttendeeService;
  public _eventItemService: EventItemService;
  public _translationService: TranslationService;
  public _dataGridService: DatagridService;
  public _eventService: EventsService;
  public _eventsToolbarBroadcastService: WlEventsToolbarBroadcastService;
  public _navigationService: NavigationService;
  public _massCommParameterService: MassCommParameterService;

  public _selectedAttendeeHeaderIds: Array<number>;
  public _unselectedAttendeeHeaderIds: Array<number>;
  public _selectAllAttendees: boolean;

  public attendeeSearchResult: AttendeeSearchResult;
  public unfilteredAttendeeSearchResult: AttendeeSearchResult = new AttendeeSearchResult();
  @Input() public event: EventRead;

  public initialLoadComplete: boolean;
  public searchParams: AttendeeSearchParams;
  public eventId: number;
  public showDetails: boolean;
  public showAdvancedSearch: boolean;
  public eventItems: Array<EventItemSummary>;

  public sortByFields: Array<NameValue>;
  public isSearching: boolean;
  public selectedAction: number;
  public actions: Array<NameValue>;
  public executing: boolean;
  public pageSizeSelection: number;
  public pageSize: number;
  public tableName: string;
  public custom2: string;
  public custom3: string;
  public custom4: string;
  public custom5: string;

  public flagOrUnflagAsAttended: boolean;
  public showModal = false;
  public constructor(
    routerService: Router,
    eventService: EventsService,
    route: ActivatedRoute,
    utilService: UtilService,
    attendeeService: AttendeeService,
    eventItemService: EventItemService,
    translationService: TranslationService,
    registrationService: RegistrationService,
    dialogService: DialogService,
    dataGridService: DatagridService,
    notifyService: NotificationService,
    eventsToolbarBroadcastService: WlEventsToolbarBroadcastService,
    navigationService: NavigationService,
    massCommParameterService: MassCommParameterService
  ) {
    this._route = route;
    this._routerService = routerService;
    this._utilService = utilService;
    this._registrationService = registrationService;
    this._attendeeService = attendeeService;
    this._eventItemService = eventItemService;
    this._translationService = translationService;
    this._dialogService = dialogService;
    this._dataGridService = dataGridService;
    this._notifyService = notifyService;
    this._selectedAttendeeHeaderIds = new Array<number>();
    this._unselectedAttendeeHeaderIds = new Array<number>();
    this._selectAllAttendees = false;
    this._eventService = eventService;
    this._eventsToolbarBroadcastService = eventsToolbarBroadcastService;
    this._navigationService = navigationService;
    this._massCommParameterService = massCommParameterService;

    this.event = new EventRead();
    this.initialLoadComplete = false;
    this.attendeeSearchResult = new AttendeeSearchResult();
    this.searchParams = new AttendeeSearchParams();
    this.searchParams.OrderBy = 'SignUpDate:desc';
    this.searchParams.PageSize = 20;

    this.eventId = 0;
    this.showDetails = false;
    this.showAdvancedSearch = false;
    this.eventItems = new Array<EventItemSummary>();
    this.sortByFields = new Array<NameValue>();
    this.isSearching = false;
    this.selectedAction = 0;
    this.actions = new Array<NameValue>();
    this.executing = false;

    this.flagOrUnflagAsAttended = false;
    this.pageSizeSelection = 1;
    this.pageSize = 20;
  }

  ngOnInit() {
    this._route.params.subscribe((params: any) => {
      if (this._utilService.isNotNullOrUndefined(params['id'])) {
        this.eventId = Number(params['id']);
        this.searchParams.EventId = this.eventId;

        this._attendeeDataGrid.reset();

        this._eventItemService.getEventItems(this.eventId).then((data: Array<any>) => {
          for (let item of data) {
            item.Selected = false;
          }

          this.eventItems = data;
        });
      }
    });

    // setup sort by dropdown
    let nv1 = new NameValue();
    let nv2 = new NameValue();
    let nv3 = new NameValue();
    let nv4 = new NameValue();
    let nv5 = new NameValue();
    let nv6 = new NameValue();
    let nv7 = new NameValue();
    let nv8 = new NameValue();
    let nv9 = new NameValue();
    let nv10 = new NameValue();
    let nv11 = new NameValue();
    let nv12 = new NameValue();

    nv1.name = 'Sign Up Date (desc)';
    nv1.value = 'SignUpDate:desc';
    nv2.name = 'Sign Up Date (asc)';
    nv2.value = 'SignUpDate:asc';

    nv3.name = 'Org Name (asc)';
    nv3.value = 'OrgName:asc';
    nv4.name = 'Org Name (desc)';
    nv4.value = 'OrgName:desc';

    nv5.name = 'First Name (asc)';
    nv5.value = 'FirstName:asc';
    nv6.name = 'First Name (desc)';
    nv6.value = 'FirstName:desc';

    nv7.name = 'Last Name (asc)';
    nv7.value = 'LastName:asc';
    nv8.name = 'Last Name (desc)';
    nv8.value = 'LastName:desc';

    nv9.name = 'Amount Due (asc)';
    nv9.value = 'AmountDue:asc';
    nv10.name = 'Amount Due (desc)';
    nv10.value = 'AmountDue:desc';

    //RegistrationOrgName
    nv11.name = 'Registration Org Name (asc)';
    nv11.value = 'RegistrationOrgName:asc';
    nv12.name = 'Registration Org Name (desc)';
    nv12.value = 'RegistrationOrgName:desc';

    this.sortByFields.push(nv1);
    this.sortByFields.push(nv2);
    this.sortByFields.push(nv3);
    this.sortByFields.push(nv4);
    this.sortByFields.push(nv5);
    this.sortByFields.push(nv6);
    this.sortByFields.push(nv7);
    this.sortByFields.push(nv8);
    this.sortByFields.push(nv9);
    this.sortByFields.push(nv10);
    this.sortByFields.push(nv11);
    this.sortByFields.push(nv12);

    // setup actions dropdown
    this._translationService.getTitlecase('events.registration.management.actions.select-action').then((data: string) => {
      let action0 = new NameValue();
      action0.name = data;
      action0.value = 0;
      this.actions.push(action0);
    });

    this._translationService.getTitlecase('events.attendees.management.actions.export-attendees').then((data: string) => {
      let action1 = new NameValue();
      action1.name = data;
      action1.value = 1;
      this.actions.push(action1);
    });

    this._translationService.getTitlecase('events.attendees.management.actions.flag-selected-as-attended').then((data: string) => {
      this.actions.push(new NameValue(data, 2));
    });

    this._translationService.getTitlecase('events.attendees.management.actions.flag-selected-as-not-attended').then((data: string) => {
      this.actions.push(new NameValue(data, 3));
    });

    this._translationService.getTitlecase('events.attendees.management.actions.print-name-badges').then((data: string) => {
      this.actions.push(new NameValue(data, 4));
    });
    this._translationService
      .getTitlecase('events.registration.management.actions.add-selected-profiles-to-affiliation')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 5));
      });
    this._translationService.getTitlecase('events.attendees.management.actions.email-these-attendees').then((data: string) => {
      this.actions.push(new NameValue(data, 6));
    });
    this._translationService.getTitlecase('events.attendees.management.actions.export-attendees-extended').then((data: string) => {
      this.actions.push(new NameValue(data, 7));
    });
    this._translationService.getTitlecase('events.attendees.management.actions.export-attendees-extended-excel').then((data: string) => {
      this.actions.push(new NameValue(data, 10));
    });
    this._translationService.getTitlecase('events.attendees.management.actions.export-selected-attendees-extended').then((data: string) => {
      this.actions.push(new NameValue(data, 8));
    });
    this._translationService.getTitlecase('events.attendees.management.actions.assign-table-selected-attendees').then((data: string) => {
      this.actions.push(new NameValue(data, 9));
    });
    this._translationService
      .getTitlecase('events.attendees.management.actions.update-custom-fields-selected-attendees')
      .then((data: string) => {
        this.actions.push(new NameValue(data, 11));
      });
  }

  public handleAttendeeGridPageSizeChange = (data: string): void => {
    this.pageSizeSelection = parseInt(data);
    var pageNum = 0;

    switch (this.pageSizeSelection) {
      case 1:
        this.pageSize = 20;
        pageNum = 1;
        break;
      case 2:
        this.pageSize = 100;
        pageNum = 1;
        break;
      case 3:
        this.pageSize = 0;
        pageNum = 0;
        break;
      default:
        break;
    }

    this.searchParams.PageSize = this.pageSize;
    this.searchParams.PageNumber = pageNum;
    // forces the grid's paginator to update it's numbers
    this.attendeeSearchResult.TotalCount = 0;
    this.startSearch();
  };

  public lazyLoadAttendees = ($event: any): void => {
    this._dataGridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    // override grid request and get all attendees
    if (this.pageSize == 0) {
      this.searchParams.PageNumber = 0;
      this.searchParams.PageSize = 0;
    }

    if (this.isSearching == false) {
      this.getAttendees();
    }
  };

  public getAttendees = (): void => {
    this.searchParams.EventItemIds = new Array<number>();
    this.updateAttendeeTotals();

    for (let item of <any>this.eventItems) {
      if (item.Selected == true) {
        this.searchParams.EventItemIds.push(item.EventItemId);
      }
    }

    if (this.searchParams.EventId > 0) {
      this.isSearching = true;
      this._attendeeService.searchAttendees(this.searchParams).then(
        (data: AttendeeSearchResult) => {
          if (data.PageSize == 0) {
            this.pageSize = data.TotalCount;
          }
          this._dataGridService.mapPagedResultsToPagedSearch(data, this.searchParams);

          this.attendeeSearchResult = data;

          for (let attendee of this.attendeeSearchResult.Result) {
            if (this._selectAllAttendees == true) {
              attendee.Selected = !this._utilService.arrayContainsValue(this._unselectedAttendeeHeaderIds, attendee.AttendeeId);
            } else {
              attendee.Selected = this._utilService.arrayContainsValue(this._selectedAttendeeHeaderIds, attendee.AttendeeId);
            }
          }
          this.initialLoadComplete = true;
          this.isSearching = false;
        },
        () => {
          this.isSearching = false;
        }
      );
    }
  };

  /**
   * starts the search over at page 1
   */
  public search() {
    this.searchParams.PageNumber = 1;
    this.startSearch();
  }

  public startSearch(): void {
    this._attendeeDataGrid.reset();
  }

  public editAttendee = (attendee: AttendeeMin): void => {
    this._eventsToolbarBroadcastService.broadcast({
      type: WlEventsToolbarEventTypeEnum.editAttendee,
      data: { EventId: this.event.EventId, RegistrationId: Number(attendee.RegistrationId), AttendeeId: attendee.AttendeeId },
    });
  };

  public toggleAdvancedSearch(): void {
    if (this.showAdvancedSearch) this.closeAdvancedSearch();
    else this.openAdvancedSearch();
  }

  public openAdvancedSearch = (): void => {
    this.showAdvancedSearch = true;
  };

  public closeAdvancedSearch = (): void => {
    this.showAdvancedSearch = false;
  };

  public deleteAttendee = (attendee: AttendeeMin): void => {};

  public actionChanged = (data: string): void => {
    this.selectedAction = parseInt(data);
  };

  public executeAction = (): void => {
    this.addActionSearchParams();
    this.executing = true;
    switch (this.selectedAction) {
      case 0:
        //for test get selected attendees to run action against
        let message =
          'Include Attendees:  ' +
          this.searchParams.AttendeeIds.toString() +
          ' -- ' +
          'Exclude Attendees:  ' +
          this.searchParams.ExcludedAttendeeIds.toString();

        this._dialogService.info(message);
        this.executing = false;
        break;
      case 1:
        this.executing = true;
        this._attendeeService.exportAttendees(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.executing = false;
          },
          () => {
            this.executing = false;
          }
        );
        break;
      case 2:
        ////flag as attended
        this.selectAllEventItems();
        this.flagOrUnflagAsAttended = true;
        this.showModal = true;

        //this.getAllSeletedAttendeeIds().then((data: Array<number>) => {

        //    this._attendeeService.updateAttendedFlag(data, true);
        //    this.executing = false;
        //}, () => { this.executing = false; });
        ////update ui
        //for (let attendee of this.attendeeSearchResult.Result) {
        //    if (attendee.Selected == true) {
        //        attendee.Attended = true;
        //    }
        //}
        break;

      case 3:
        /////flag as not attended
        this.selectAllEventItems();
        this.flagOrUnflagAsAttended = false;
        this.showModal = true;

        //this.getAllSeletedAttendeeIds().then((data: Array<number>) => {

        //    this._attendeeService.updateAttendedFlag(data, false);

        //    this.executing = false;
        //}, () => { this.executing = false; });

        ////update ui
        //for (let attendee of this.attendeeSearchResult.Result) {
        //    if (attendee.Selected == true) {
        //        attendee.Attended = false;
        //    }
        //}
        break;

      case 4:
        this._eventService.getNameBadgeReportUrl(this.eventId).then(url => this._navigationService.popupSafeNavigate(url));
        this.executing = false;
        break;

      case 5:
        this.getAllSeletedAttendeeIds().then(
          (data: Array<number>) => {
            let attendeeHeaderIds = data;
            this._attendeeService.getProfileIdsForAttendeeHeaderIds(attendeeHeaderIds).then(
              (data: Array<number>) => {
                let profileIds = data;
                this.massAddAffCode.setProfileIds(profileIds);
                this.massAddAffCode.addAffCodes();
                this.executing = false;
              },
              () => {
                this.executing = false;
              }
            );
          },
          () => {
            this.executing = false;
          }
        );

        break;

      case 6:
        this.getAllSeletedAttendeeIds().then(
          (data: Array<number>) => {
            let attendeeHeaderIds = data;
            let search = new AttendeeSearchParams();
            search.EventId = this.eventId;
            search.AttendeeIds = attendeeHeaderIds;
            search.PageSize = 99999999;
            this._attendeeService.searchAttendees(search).then(
              (data: AttendeeSearchResult) => {
                let emailProfileIds = new Array<number>();
                let emailManuals = new Array<NameValue>();
                for (let attendee of data.Result) {
                  if (attendee.ProfileId > 0) {
                    emailProfileIds.push(attendee.ProfileId);
                  } else {
                    if (this._utilService.isNotNullEmptyOrWhitespace(attendee.Email)) {
                      let displayName = '';
                      if (this._utilService.isNotNullEmptyOrWhitespace(attendee.NameForBadge)) {
                        displayName = attendee.NameForBadge;
                      } else if (this._utilService.isNotNullEmptyOrWhitespace((attendee.FName + ' ' + attendee.LName).trim())) {
                        displayName = attendee.FName + ' ' + attendee.LName.trim();
                      } else {
                        displayName = attendee.OrgName;
                      }
                      let nv = new NameValue(displayName, attendee.Email);
                      emailManuals.push(nv);
                    }
                  }
                }

                this._massCommParameterService.setEventId(this.eventId);
                this._massCommParameterService.setFromType('attendees');
                this._massCommParameterService.setEmailParams(emailManuals);
                this._massCommParameterService.setProfileIdParams(emailProfileIds);
                let navFrom = new MassCommParamNav();
                navFrom.DisplayText = this._translationService.getInstantCapitalizeFirstCharacter('events.labels.back-to-event');
                navFrom.NavigatedFromRoute = '/event/' + this.eventId.toString() + '/attendees';
                this._massCommParameterService.setNavigatedFromParams(navFrom);
                this._navigationService.navigateToCommunicationNewEmailMessage();
              },
              () => {
                this.executing = false;
              }
            );

            //this._registrationService.emailAttendees(attendeeHeaderIds).then((sendEmailUrl: string) => {
            //    //returns the URL toolbar email form
            //    if (sendEmailUrl)
            //        this._navigationService.popupSaefeNavigate(sendEmailUrl);
            //    this.executing = false;
            //}, () => { this.executing = false; });
          },
          () => {
            this.executing = false;
          }
        );

        break;

      case 7:
        this.executing = true;
        this._attendeeService.exportAttendeesExtended(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.executing = false;
          },
          () => {
            this.executing = false;
          }
        );
        break;

      case 10:
        this.executing = true;
        this._attendeeService.exportAttendeesExtendedAsExcel(this.eventId).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this.executing = false;
          },
          () => {
            this.executing = false;
          }
        );
        break;

      case 8:
        this.executing = true;
        this.getAllSeletedAttendeeIds().then((data: Array<number>) => {
          let attendeeHeaderIds = data;

          this._attendeeService.exportAttendeesExtendedAndFiltered(this.eventId, attendeeHeaderIds).then(
            (data: string) => {
              this._navigationService.popupSafeNavigate(data);
              this.executing = false;
            },
            () => {
              this.executing = false;
            }
          );
        });

        break;
      case 9:
        this.executing = true;
        this.getAllSeletedAttendeeIds().then((data: Array<number>) => {
          let attendeeHeaderIds = data;

          let assignAttendeeTable: AssignAttendeeTable = new AssignAttendeeTable();
          assignAttendeeTable.AttendeeHeaderIds = attendeeHeaderIds;
          assignAttendeeTable.TableName = this.tableName;
          this._attendeeService.assignAttendeesToTable(assignAttendeeTable).then(
            () => {
              this.executing = false;

              let message: string = this._translationService.getInstant('events.attendees.management.actions.assign-table-success');
              this._notifyService.success(message);
            },
            () => {
              this.executing = false;

              let message: string = this._translationService.getInstant('events.attendees.management.actions.assign-table-error');
              this._dialogService.error(message);
            }
          );
        });
        break;
      case 11:
        this.executing = true;
        this.getAllSeletedAttendeeIds().then((data: Array<number>) => {
          let attendeeHeaderIds = data;

          let updateAttendeeCustomFields: UpdateAttendeeCustomFields = new UpdateAttendeeCustomFields();
          updateAttendeeCustomFields.AttendeeHeaderIds = attendeeHeaderIds;
          updateAttendeeCustomFields.Custom2 = this.custom2;
          updateAttendeeCustomFields.Custom3 = this.custom3;
          updateAttendeeCustomFields.Custom4 = this.custom4;
          updateAttendeeCustomFields.Custom5 = this.custom5;
          this._attendeeService.updateAttendeesCustomFields(updateAttendeeCustomFields).then(
            () => {
              this.executing = false;

              let message: string = this._translationService.getInstant('events.attendees.management.actions.update-custom-fields-success');
              this._notifyService.success(message);
            },
            () => {
              this.executing = false;

              let message: string = this._translationService.getInstant('events.attendees.management.actions.update-custom-fields-error');
              this._dialogService.error(message);
            }
          );
        });
        break;
      default:
        break;
    }

    this.clearActionSearchParams();
  };

  public selectAll = ($event: any): void => {
    this._selectAllAttendees = $event.target.checked;

    //reset the tracking arrays
    this._selectedAttendeeHeaderIds = new Array<number>();
    this._unselectedAttendeeHeaderIds = new Array<number>();

    for (let attendee of this.attendeeSearchResult.Result) {
      attendee.Selected = $event.target.checked;
    }
  };

  public selectOrUnselectAttendee = (attendee: AttendeeMin): void => {
    if (attendee.Selected == true) {
      this._selectedAttendeeHeaderIds.push(attendee.AttendeeId);
      this._utilService.arrayRemoveEntry(this._unselectedAttendeeHeaderIds, attendee.AttendeeId);
    } else {
      this._unselectedAttendeeHeaderIds.push(attendee.AttendeeId);
      this._utilService.arrayRemoveEntry(this._selectedAttendeeHeaderIds, attendee.AttendeeId);
    }
  };

  public getAllSeletedAttendeeIds = (): Promise<Array<number>> => {
    if (this._selectAllAttendees == true) {
      let searchParams: AttendeeSearchParams = <AttendeeSearchParams>JSON.parse(JSON.stringify(this.searchParams));
      searchParams.PageNumber = 0;
      searchParams.PageSize = 0;
      searchParams.OrderBy = '';

      return this._attendeeService.getAttendeeHeaderIdsForEvent(this.eventId, searchParams).then((attendeeIds: Array<number>) => {
        if (!this._unselectedAttendeeHeaderIds) return attendeeIds;

        if (attendeeIds) return attendeeIds.filter(x => this._unselectedAttendeeHeaderIds.indexOf(x) < 0);
        return [];
      });
    } else {
      return Promise.resolve(this._selectedAttendeeHeaderIds);
    }
  };

  public addActionSearchParams = (): void => {
    //get any selected attendees
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = 99999;

    if (this._selectAllAttendees == true) {
      this.searchParams.AttendeeIds = new Array<number>();
      this.searchParams.ExcludedAttendeeIds = this._unselectedAttendeeHeaderIds;
    } else {
      this.searchParams.AttendeeIds = this._selectedAttendeeHeaderIds;
      this.searchParams.ExcludedAttendeeIds = new Array<number>();
    }
  };

  public clearActionSearchParams = (): void => {
    this._dataGridService.mapPagedResultsToPagedSearch(this.attendeeSearchResult, this.searchParams);

    this.searchParams.AttendeeIds = new Array<number>();
    this.searchParams.ExcludedAttendeeIds = new Array<number>();
  };

  /**
   * sets all the search and advanced search fields to default
   */
  public resetSearchForm() {
    this.searchParams.Keyword = '';
    this.searchParams.SearchAnySignUpDate = true;
    this.searchParams.SignUpStartDate = new Date();
    this.searchParams.SignUpEndDate = new Date();
    this.searchParams.AllUnpaid = false;
    this.searchParams.AllWithBlankAttendees = false;
    this.searchParams.AllWithProfileIdNotAssigned = false;

    if (this.eventItems) this.eventItems.forEach(x => ((<any>x).Selected = false));
  }

  /**
   * resets the form and starts a fresh search
   */
  public resetAndSearch() {
    this.resetSearchForm();
    this.startSearch();
  }

  /**
   * triggered when a registration is saved
   */
  public handleRegistrationSaved() {
    this.getAttendees();
  }

  public selectAllEventItems() {
    for (let eventItem of this.eventItems) {
      eventItem.Selected = true;
    }
  }
  public flagOrUnflagAttendeesForSelectedEventItems = (): void => {
    this.showModal = false;

    this.executing = true;

    this.getAllSeletedAttendeeIds().then(
      (data: Array<number>) => {
        let dto: AttendedFlagOrUnflag = new AttendedFlagOrUnflag();
        let selectedEventItems = new Array<number>();
        for (let eventItem of this.eventItems) {
          if (eventItem.Selected == true) {
            selectedEventItems.push(eventItem.EventItemId);
          }
        }
        dto.Attended = this.flagOrUnflagAsAttended;
        dto.AttendeeHeaderIds = data;
        dto.EventItemIds = selectedEventItems;

        this._attendeeService.updateAttendedFlagForEventItems(dto);

        this.executing = false;
      },
      () => {
        this.executing = false;
      }
    );
    //update ui
    for (let attendee of this.attendeeSearchResult.Result) {
      if (attendee.Selected == true) {
        attendee.Attended = this.flagOrUnflagAsAttended;
      }
    }
  };

  public cancelSelectedEventItems = (): void => {
    this.executing = false;
    this.showModal = false;
  };

  /**
   * calls the attendee search with no filter to get total attendees for event
   */
  public updateAttendeeTotals(): void {
    let params = new AttendeeSearchParams();
    params.PageNumber = 1;
    params.PageSize = 1;
    params.EventId = this.eventId;

    this._attendeeService.searchAttendees(params).then(results => (this.unfilteredAttendeeSearchResult = results));
  }

  /**
   * triggered by clicking "# with no profile id)
   */
  public handleAttendeesWithNoProfileIdClick(): void {
    this.searchParams.AllWithProfileIdNotAssigned = true;
    this.openAdvancedSearch();
    this.search();
  }

  /**
   * triggered by checking/unchecking the attended checkbox
   */
  public handleAttendeeAttendedCheckChanged(attendee: AttendeeMin): void {
    var attendeeAny: any = <any>attendee;

    if (attendeeAny._updatingAttendedFlag) return;

    attendeeAny._updatingAttendedFlag = true;
    let newAttendedValue = attendee.Attended;

    this._attendeeService.updateAttendedFlag([attendee.AttendeeId], newAttendedValue).then(
      () => (attendeeAny._updatingAttendedFlag = false),
      () => {
        // failed, switch it back
        attendee.Attended = !newAttendedValue;
        attendeeAny._updatingAttendedFlag = false;
      }
    );
  }
}
